import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/index.css';

ReactDOM.hydrateRoot(
  document.getElementById('root')!,
  <React.StrictMode><BrowserRouter><App /></BrowserRouter></React.StrictMode>,
);
